import { render, staticRenderFns } from "./she80.vue?vue&type=template&id=e16e4d1a&scoped=true"
import script from "./she80.vue?vue&type=script&lang=ts"
export * from "./she80.vue?vue&type=script&lang=ts"
import style0 from "./she80.vue?vue&type=style&index=0&id=e16e4d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16e4d1a",
  null
  
)

export default component.exports